import { formatDate } from "@angular/common";
import { Inject, Injectable, LOCALE_ID } from "@angular/core";
import { TramiteDto } from "src/app/listado/listado-tramites-emvs/listado-tramites-emvs.component";
import { TramiteEmvs } from "src/app/listado/listado-tramites-emvs/tramite-emvs";
import { ResponseTramiteElement } from "src/app/model/respuesta_tramite_modelo";

@Injectable({
  providedIn: "root",
})
export class CsvgenerateService {

  constructor(
    @Inject(LOCALE_ID) public locale: string,
  ) { }

  downloadFile(csvData: string): void {
    let blob = new Blob(["\ufeff" + csvData], {
      type: "text/csv;charset=utf-8;",
    });
    let dwldLink = document.createElement("a");
    let url = URL.createObjectURL(blob);
    dwldLink.setAttribute("href", url);
    dwldLink.setAttribute("download", "listado_tramites.csv");
    dwldLink.click();
  }

  cabeceras_tramite: string[] = [
    "id_tramite",
    "fechaAlta_tramite",
    "fechaModificacion_tramite",
    "pdfCliente_tramite",
    "pdfServidor_tramite",
    "estado_tramite",
  ]
  cabeceras_usuario: string[] = [
    'nombre_usuario',
    'apellido1_usuario',
    'apellido2_usuario',
    'email_usuario',
    'documento_usuario',
  ];
  cabeceras_procedimiento3: string[] = [
    'nombre_procedimiento',
    'tipo_procedimiento',
    'nombre_departamento',
    'curriculum',
    'titulacion',
  ];
  cabeceras_procedimiento1: string[] = [
    'nombre_procedimiento',
    'nombre_departamento',
    'nombre_representante',
    'apellidos_representante',
    'documento_representante',
    'cp_representante',
    'provincia_representante',
    'tipo_via_representate',
    'direccion_representante',
    'numero_calle_representante',
    'portal_representante',
    'escalera_representante',
    'planta_representante',
    'puerta_representante',
    'telefono1_representante',
    'telefono2_representante',
    'email_representante',
    'expone',
    'solicita',
    'documento_adjunto'
  ];

  generateCsvEmvs = (tramites: Map<String, any[]>) => {
    let csvData = this.csvmakerTramite(tramites);
    this.downloadFile(csvData);
  };

  private csvmakerTramite = (data: Map<String,any[]>) => {
    let csvRows = [];
    let id:number;    
    
    let numHeadersPuestos : number = 0;
    Object.keys(data).forEach(key =>{
      
      if(key == '1'){
        let csvHeaders = [];
        const headers = this.cabeceras_tramite.concat(this.cabeceras_usuario).concat(this.cabeceras_procedimiento1);
        csvRows.push(headers.join(';'));
        data[key].forEach(element => {
          let csvData = [];
          if(id == element[0]){
            csvHeaders.push('documento_adjunto');
            csvRows[csvRows.length-1]+=';'+element[element.length-1];

          } else {
            element.forEach(campo => {
              if(campo != null){
                for(var i = 0; i<campo.length; i++){
                  if(campo.toString().indexOf('\n') > -1){
                    
                    campo = campo.toString().replace('\n','');
                    campo = campo.toString().replace(',',' ');
                  }
                }
              }
              
              if(campo == element[1] || campo == element[2]){
                let date = new Date(campo);
                campo = formatDate(date, 'dd-MM-yyyy HH:mm', this.locale);
              }
              csvData.push(campo)

              id = element[0];
            })
          }          
          csvRows.push(csvData.join(';'))
          
        })
      } else if(key == '3'){
        let csvHeaders = [];

        let csvBody : string = "";
        const headers = this.cabeceras_tramite.concat(this.cabeceras_usuario).concat(this.cabeceras_procedimiento3);
        csvHeaders.push(headers.join(';'));
        
        data[key].forEach(element => {
          let csvData = [];
          let csvData2 = [];
          
          csvData.push(element.id ?? '')
          csvData.push(element.fechaAlta ?? '')
          csvData.push(element.fechaModificacion ?? '')
          csvData.push(element.pdfCliente ?? '')
          csvData.push(element.pdfServidor ?? '')
          csvData.push(element.estadoFirma ?? '')
          csvData.push(element.usuario_id.nombre ?? '')
          csvData.push(element.usuario_id.apellido1 ?? '')
          csvData.push(element.usuario_id.apellido2 ?? '')
          csvData.push(element.usuario_id.email ?? '')
          csvData.push(element.usuario_id.numero_documento ?? '')
          csvData.push(element.procedimiento_id.nombre ?? '')
          csvData.push(element.procedimiento_id.departamento.nombre ?? '')

          if(element.puestos.length != 0){
            csvData2.push(element.puestos[0].idDocumento1);
            csvData2.push(element.puestos[0].idDocumento2);
            element.puestos[0].solicitudes.forEach(solicitud => {
              if(element.puestos[0].solicitudes.length > numHeadersPuestos){ 
                numHeadersPuestos = element.puestos[0].solicitudes.length;
              }
              csvData2.push(solicitud.convocatoria);
              csvData2.push(solicitud.denominacion.nombre);
              csvData2.push(solicitud.denominacion.puesto);
            })
          }
          csvData.push(csvData2.join(';'));
          csvBody+=csvData.join(';') + '\n';
        });

        for(let i=0 ; i < numHeadersPuestos; i++){
          csvHeaders.push('convocatoria', 'denominacion', 'puesto');
        }

        csvRows.push(csvHeaders.join(';'));
        csvRows.push(csvBody.concat(';'));
      }
    })
    
    return csvRows.join('\n')
  }
}
